// src/components/auth/PrivateRoute.js
import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

export const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    // If not loading and not authenticated, redirect to login with return URL
    if (!isLoading && !isAuthenticated) {
      console.log('User not authenticated, redirecting to login');
      console.log('Current location:', location.pathname + location.search);
      
      loginWithRedirect({
        appState: {
          returnTo: location.pathname + location.search
        }
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, location]);

  if (isLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // If authenticated, render the protected component
  if (isAuthenticated) {
    return children;
  }

  // If not authenticated, return null (redirect happens in useEffect)
  // This prevents any flash of content before redirect
  return null;
};

export default PrivateRoute;